<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_1"
			>
				<div v-if="infoData" class="tit_box">
					<div class="tit">{{ infoData.title }}</div>
					<div class="time">{{ infoData.fabu_time }}</div>
				</div>
				<div v-if="infoData" v-html="infoData.content" class="content_box"></div>
				<div class="check_box">
					<div v-if="prevList" class="check_box_el">
						<div class="tit">Prev:&ensp;</div>
						<div class="txt" @click="goInfo(prevList)">{{ prevList.title }}</div>
					</div>
					<div v-if="nextList" class="check_box_el">
						<div class="tit">Next:&ensp;</div>
						<div class="txt" @click="goInfo(nextList)">{{ nextList.title }}</div>
					</div>
				</div>
			</div>
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { newsInfo } from '@/api/public';  //新闻列表
import { UPURL } from '@/util/util';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nextList: null,
			prevList: null,
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
		//请求详情接口
		if(that.$route.params.newInfoId) {
			that.getInfo(that.$route.params.newInfoId.split('.')[0]);
		}else {
			that.$toast('Error');
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//请求数据
		getInfo(value) {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			newsInfo({ id: value }).then(res => {
				that.infoData = res.data.info;
				that.nextList = res.data.nextinfo;
				that.prevList = res.data.preinfo;
				that.$toast.clear();
			});
		},
		//进入详情
		goInfo(value) {
			let that = this;
			that.$router.push({ name: 'NewsInfo', params: { newInfoId: value.id + '.html' } });
			setTimeout(() => {
				window.location.reload();
			}, 300);
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_1{
		padding: 40px 16px;
		.check_box{
			.check_box_el{
				display: flex;
				margin: 7px 0;
				.txt{
					flex: 1;
					line-height: 1.8;
				}
				.tit{
					width: auto;
				}
			}
		}
		.content_box{
			margin-bottom: 40px;
			padding: 40px 0;
			border-bottom: 1px solid #B8B8B8;
			word-break: break-all;
		}
		.tit_box{
			.time{
				padding-top: 15px;
				text-align: center;
				font-size: 12px;
				color: #B8B8B8;
			}
			.tit{
				padding: 0 40px;
				font-size: 18px;
				font-weight: bold;
				text-align: center;
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .content_box img{
	max-width: 100%;
	height: auto;
}
</style>